/*
*
* File JS per l'archivio soluzioni
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import bannerImage from '../../components/banner-image/banner-image.js';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './soluzioni-archive.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

addEventListener('DOMContentLoaded', (evt) =>
{
    bannerImage();
});

//--------------------------------------------------------------------//